import { create } from "zustand";

interface AppState {
  isAgentMode: boolean;
  setIsAgentMode: (isAgentMode: boolean) => void;
}

export const useAppStore = create<AppState>()(
  (set) => ({
    isAgentMode: false,
    setIsAgentMode: (isAgentMode: boolean) => set((_) => ({ isAgentMode })),
  }),
);
